import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageStateService {
  private pageState = 0;

  set page(page: number) {
    sessionStorage.setItem('page', String(page));
    this.pageState = page;
  }

  get page(): number {
    const storagePage = sessionStorage.getItem('page');
    if (this.pageState === 0) {
      this.page = Number(storagePage);
    }
    return this.pageState;
  }
}
